import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { Referral } from "@roman/shared/types/Referral";
import { useEffect } from "react";
import useSWR from "swr";
import { authHeader } from "../lib/auth/authHeader";

const fetcher = (url: string) => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<Referral>(`${url}`, undefined, { headers });
};

export const useGetOrCreateReferral = (handleError: (err: RomanApiError) => void) => {
  const { data, error, mutate, isLoading } = useSWR(
    // The previous run's referral code should not be cached.
    authHeader.get() ? ["/referral"] : null,
    ([url]) => fetcher(url),
  );

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data,
    isLoading,
    error,
    mutate,
  };
};
